<div class="request-review-modal" *renderingPermissionDirective="['BulkSettingReviewer']">

  <div class="request-review-modal__header">
    <span class="request-review-modal__header__label">Request {{ requestId }}</span>
    <button class="lx-icon lx-close-x request-review-modal__header__close float-end" (click)="cancel()"></button>

  </div>

  <ng-template #loadingTemplate>
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </ng-template>

  <div class="request-review-modal__body" *ngIf="!loading; else loadingTemplate">

    <display-entities [entities]="entitiesList"></display-entities>

    <div class="request-review-modal__body__field">
      <label for="request-date">Request Date</label>
      <div class="request-review-modal__body__request-date__value" id="request-date">
        {{ requestDate }}
      </div>
    </div>

    <div class="request-review-modal__body__field">
      <label for="requester">Requester Name</label>
      <div class="request-review-modal__body__requester__value" id="requester">
        {{ settingsUpdateRequest.requester || '' }}
      </div>
    </div>

    <div class="request-review-modal__body__field">
      <label for="description">Description</label>
      <div class="request-review-modal__body__description__value" id="description">
        {{ settingsUpdateRequest.description || '' }}
      </div>
    </div>

    <div class="request-review-modal__body__settings">
      <table>
        <thead>
          <tr>
            <th>Setting</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let setting of settings">
            <td>{{setting.name}}</td>
            <td>{{setting.displayValue}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <form [formGroup]="reviewRequestForm">
      <div class="request-review-modal__review">
        <div class="request-review-modal__review__description">
          <label for="description">Review Description</label>
          <textarea id="description" formControlName="description" type="text" required></textarea>
        </div>
        <div class="request-review-modal__review__buttons d-flex justify-content-center">
          <button class="lx-btn lx-btn-secondary" type="button"
            [disabled]="reviewRequestForm.controls['description'].invalid || reviewed"
            (click)="review(false)">Reject</button>
          <button class="lx-btn lx-btn-primary" type="button"
            [disabled]="reviewRequestForm.controls['description'].invalid || reviewed"
            (click)="review(true)">Approve</button>
        </div>
      </div>
    </form>

  </div>

</div>